// extracted by mini-css-extract-plugin
export default {"operationArea":"TenantPrefabRole_operationArea__tQ0mT"};